import { EmPrivileges, CctvPrivileges, DmsPrivileges, MasPrivileges, RwisPrivileges, TssPrivileges } from 'NSwag/ServerClient/Client.nswag';
import { PrivilegesAction } from 'Actions/index';
import { PrivilegesActionTypes } from 'Actions/ActionTypes/index';
import { IPrivileges } from 'Store/IPrivileges';

const initialState: IPrivileges = {
    cctv: new CctvPrivileges(),
    dms: new DmsPrivileges(),
    em: new EmPrivileges(),
    mas: new MasPrivileges(),
    rwis: new RwisPrivileges(),
    tss: new TssPrivileges()
}

export const permissions = (state: IPrivileges = initialState , action: PrivilegesAction) => {

    let newState: any;

    switch (action.type) {
        case PrivilegesActionTypes.Set:
            newState = action.privileges;
            break;
        case PrivilegesActionTypes.Clear:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
}